<ng-container *ngIf="!!showHeader && contract$ | async as contract">
    <ng-container *ngIf="!isApp">
        <edp-header-contract></edp-header-contract>
    </ng-container>

    <ng-container *ngIf="contract.HasRedy">
        <edp-redy-card-bar></edp-redy-card-bar>
    </ng-container>
</ng-container>

<ng-container *ngIf="!!showHeader && contractES$ | async as contractEs">
    <ng-container *ngIf="!isApp">
        <edp-header-contract></edp-header-contract>
    </ng-container>
</ng-container>

<!-- <iframe #iframeElement id="iframeElement" frameBorder="0" *ngIf="urlSafe" [src]="urlSafe" width="100%" height="100%"
    title="">
</iframe> -->